import { ComponentRef } from '@angular/core';
import { TemplateContext } from '../../../../models/reportTemplate.model';
import { EditorPropertySchema, EditorRenderStrategy, WidgetPropertyType, parseAttribute } from '../../sample-widgets/widget-config.helpers';
import { SEG_STYLES } from '../seg-profile/seg-profile-presentation.service';
import { SegProfileContext, segDefItem } from '../seg-profile/seg-widget-config.shared';
import { SegProfileHeaderWidgetComponent } from './seg-profile-header-widget.component';

export enum SegProfileHeaderWidgetAttr {
    ShowDescription = 'showDescription',
    ShowContractors = 'showContractors'
}

export function configureSegProfileHeaderWidget(
    componentRef: ComponentRef<unknown>,
    context: TemplateContext,
    sourceElement?: HTMLElement
): void {
    const component = componentRef.instance as SegProfileHeaderWidgetComponent;
    const ctx = context as SegProfileContext;
    component.profiles = ctx.computedData?.segProfiles ?? null;
    component.showDescription = parseAttribute(sourceElement?.getAttribute(SegProfileHeaderWidgetAttr.ShowDescription), true);
    component.showContractors = parseAttribute(sourceElement?.getAttribute(SegProfileHeaderWidgetAttr.ShowContractors), true);
}

// NOTE ON KNOBS IN THE PDF: the Boolean knobs (showDescription / showContractors) drive the
// interactive Angular preview via configureSegProfileHeaderWidget above. The static PDF loop
// template cannot read per-widget attributes (they are stripped when the widget element is
// replaced by this string), so — matching the shipped gravimetric-widget precedent — the loop
// template instead uses `data-tpl-if` DATA-presence guards to omit optional fields that are
// empty in the payload, rather than honouring the UI toggle.
export const segProfileHeaderLoopTemplate = [
    '[[#each computedData.segProfiles]]',
    `<div style="${SEG_STYLES.section}">`,
    `<div style="${SEG_STYLES.heading}">[[this.segName]]</div>`,
    `<p data-tpl-if="this.segDescription" style="${SEG_STYLES.description}">[[this.segDescription]]</p>`,
    `<div style="${SEG_STYLES.defGrid}">`,
    segDefItem('SEG Code', 'segCode', 'segCode'),
    segDefItem('No of Employees', 'numberOfWorkers'),
    segDefItem('No of Contractors', 'numberOfContractors', 'numberOfContractors'),
    segDefItem('Shift Type', 'shiftType', 'shiftType'),
    segDefItem('Shift Length (h)', 'shiftLengthHours', 'shiftLengthHours'),
    segDefItem('Avg Weekly Hours', 'avgWeeklyHours', 'avgWeeklyHours'),
    '</div>',
    '</div>',
    '[[/each]]'
].join('\n');

export const segProfileHeaderLoopScopes: { loopExpr: string; label: string; fields: string[] }[] = [
    {
        loopExpr: 'computedData.segProfiles',
        label: 'Per SEG',
        fields: ['segName', 'segDescription', 'segCode', 'numberOfWorkers', 'numberOfContractors', 'shiftType', 'shiftLengthHours', 'avgWeeklyHours']
    }
];

export const segProfileHeaderEditorPropertySchema: EditorPropertySchema = {
    renderStrategy: EditorRenderStrategy.ReadOnly,
    propertySchema: [
        { key: SegProfileHeaderWidgetAttr.ShowDescription, label: 'Show Description', type: WidgetPropertyType.Boolean },
        { key: SegProfileHeaderWidgetAttr.ShowContractors, label: 'Show Contractors', type: WidgetPropertyType.Boolean }
    ]
};
